import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

/**
 * 301 Redirect page for /tasks/ -> /task-management/
 * This page includes proper SEO signals for search engines:
 * - Canonical URL pointing to /task-management/
 * - Meta refresh redirect
 * - noindex to prevent indexing
 * - JavaScript redirect for browsers
 */
const TasksRedirect = () => {
  useEffect(() => {
    // Client-side redirect
    window.location.replace("/task-management/");
  }, []);

  return (
    <>
      <Helmet>
        <title>Redirecting to Task Management | CSW</title>
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://csw.live/task-management/" />
        <meta httpEquiv="refresh" content="0;url=/task-management/" />
        {/* Add HTTP status hint for crawlers */}
        <meta name="prerender-status-code" content="301" />
      </Helmet>
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <p className="text-muted-foreground">Redirecting to Task Management...</p>
          <a href="/task-management/" className="text-primary hover:underline mt-2 block">
            Click here if not redirected
          </a>
        </div>
      </div>
    </>
  );
};

export default TasksRedirect;
